<template>
  <footer>
    <div class="container">
      <div class="row">
        <div class="col-12 col-md-5">
          <div class="title">
            Get in touch
          </div>
          <div class="content">
            <a href="mailto:hello@ludimos.com">hello@ludimos.com</a>

            <br><br>
            <router-link to="/contact">
              Contact
            </router-link>
            <!-- <div class="title">
              Official partners
            </div>
            <div class="partners">
              <div class="partner">
                <a
                  href="https://sportsfever360.com/"
                  target="_blank"
                >
                  <img
                    src="../assets/img/SportsFever360.jpg"
                    alt="SportsFever360 Partner Ludimos "
                  >
                </a>
              </div>
              <div class="partner">
                <a
                  href="http://r2mi.in/"
                  target="_blank"
                >
                  <img
                    src="../assets/img/route2media.jpg"
                    alt="RouteToMarket Media India Pvt Ltd"
                  >
                </a>
              </div>
              <div class="partner">
                <a
                  href="http://www.coachingcohort.com.au/"
                  target="_blank"
                >
                  <img
                    src="../assets/img/coaching-cohort.jpg"
                    alt="Coaching Cohort Australia"
                  >
                </a>
              </div>
            </div> -->
          </div>
        </div>
        <div class="col-12 col-md-4">
          <div class="title">
            Ludimos
          </div>
          <!-- <router-link to="/pricing">
            Pricing
          </router-link>
          <br> -->
          <router-link to="/about">
            Our Team
          </router-link>
          <br>
          <router-link to="/press">
            News
          </router-link>
          <br>
          <router-link to="/latest-articles">
            Blog
          </router-link>
          <br>
          <router-link to="/support">
            FAQ
          </router-link>
          <br>
          <router-link to="/instructions">
            Video guides
          </router-link>
          <br>
        </div>
        <div class="col-12 col-md-3">
          <div class="title">
            Follow us on social media
          </div>
          <div class="social-media-links">
            <a
              href="https://www.facebook.com/ludimos/"
              target="_blank"
            >
              <img
                src="../assets/img/facebook.png"
                alt="socialmedia icon"
              >
            </a>
            <a
              href="https://www.instagram.com/ludimosofficial/"
              target="_blank"
            >
              <img
                src="../assets/img/instagram.png"
                alt="socialmedia icon"
              >
            </a>
            <a
              href="https://twitter.com/ludimos"
              target="_blank"
            >
              <img
                src="../assets/img/twitter.png"
                alt="socialmedia icon"
              >
            </a>
            <a
              href="https://www.linkedin.com/company/ludimos"
              target="_blank"
            >
              <img
                src="../assets/img/linkedin.png"
                alt="socialmedia icon"
              >
            </a>
            <a
              href="https://www.youtube.com/channel/UCotkSo63dEPe5Cud7HigbDg"
              target="_blank"
            >
              <img
                src="../assets/img/youtube.png"
                alt="socialmedia icon"
              >
            </a>
          </div>
          <br>
          <button
            class="start-trial-footer"
            @click="openDemoRequest"
          >
            Request coaching account
          </button>
          <br>
          <div class="download-app-link text-center-mobile">
            <a
              href="https://apps.apple.com/app/id1502154672"
              target="_blank"
              @click="trackIOSClick"
            >
              <img
                src="../assets/img/app-store.svg"
                alt="Download Ludimos app from the app store"
              >
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.ludimosapp"
              target="_blank"
              @click="trackAndroidClick"
            >
              <img
                src="../assets/img/play-store.svg"
                alt="Download Ludimos app from the play store"
              >
            </a>
          </div>
        </div>
      </div>
      <br>
      <hr>
      <div class="foot-note">
        <p><b>©2020 Ludimos</b>. All rights reserved</p>
        <router-link to="/software-license-agreement">
          Software license Agreement
        </router-link>

        <router-link to="/general-terms-and-conditions">
          General Terms &amp; Conditions
        </router-link>

        <router-link to="/privay-policy">
          Privacy Policy
        </router-link>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  methods: {
    trackAndroidClick() {
      this.$ma.trackEvent({
        fb_event: "Click",
        category: "Click",
        action: "Footer Android Click",
        label: "Android Click",
        type: "Android Click",
      });
    },
    trackIOSClick() {
      this.$ma.trackEvent({
        fb_event: "Click",
        category: "Click",
        action: "Footer IOS Click",
        label: "IOS Click",
        type: "IOS Click",
      });
    },
    openDemoRequest() {
      this.$ma.trackEvent({
        fb_event: "Click",
        category: "Click",
        action: "Request Demo",
        label: "Request Demo",
        type: "Request Demo",
      });
      this.$router.push({ name: "request-demo" });
      // window.open(
      //   `${process.env.VUE_APP_APP_BASE_URL}/register-club?utm_source=website&utm_medium=footer`
      // );
    },
  },
};
</script>

<style scoped lang="scss">
footer {
  background: #2b3060;
  color: #fff;
  position: relative;
  margin-top: 80px;
  &:before {
    content: "";
    display: block;
    position: relative;
    height: 76px;
    top: -75px;
    margin-top: 0;
    background: url(../assets/img/footer-wave.svg);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: bottom;
  }

  .download-app-link {
    a {
      width: calc(50% - 10px);
      background: #6f44ff;
      margin-top: 0;
      margin: 0 10px 0 0;
      + a {
        margin: 0 0 0 10px;
      }
      img {
        background: #6f44ff;
        max-width: 90%;
      }

      &:hover {
        background: #6f44ff;
        img {
          background: #6f44ff;
        }
      }
    }
  }
  .title {
    font-weight: 600;
    margin-bottom: 15px;
    opacity: 0.5;
  }

  .adresse {
    margin: 0 0 10px;
  }

  a {
    color: #fff;
    font-weight: normal;
    &:hover {
      opacity: 0.9;
    }
  }
  .social-media-links {
    a {
      display: inline-block;
      width: 30px;
      margin: 0 10px 0 0;
      height: 30px;
      img {
        max-width: 100%;
      }
    }
  }
  .newsletter {
    p {
      margin: 20px 0 10px 0;
    }
  }
  .input {
    margin: 0 10px 0 0;
    width: 50%;
  }
  .foot-note {
    margin: 30px 0;
    color: #fff;
    font-size: 13px;
    opacity: 0.7;
    text-align: center;
    a {
      color: #fff;
      margin: 0 10px 0 0;
      text-decoration: underline !important;
    }
    p {
      margin: 0;
    }
  }

  .fund-raising {
    margin: 0;
    font-size: 14px;
    opacity: 0.7;
    transition: all 0.3s ease-in-out;

    a {
      font-weight: bold;
      margin: 10px 0;
      line-height: initial;
      min-height: 0;
      height: auto;
    }
    &:hover {
      opacity: 1;
    }
  }
}
.partners {
  p {
    font-weight: 600;
    margin-bottom: 15px;
    opacity: 0.5;
  }

  .partner {
    opacity: 0.7;
    transition: all 0.3s ease-in-out;
    padding: 5px;
    background: #fff;
    border-radius: 4px;
    display: inline-block;
    box-shadow: 30px 30px 40px rgba(0, 0, 0, 0.25);
    margin: 0 10px 0 0;

    img {
      border-radius: 4px;
      height: 70px;
    }
    &:hover {
      opacity: 1;
    }
  }
}
.start-trial-footer {
  cursor: pointer;
  border-radius: 4px;
  background: none;
  border: 2px solid #fff;
  padding: 0 30px;
  height: 50px;
  width: 100%;
  display: inline-block;
  line-height: 45px;
  color: #fff;
  margin: 0 0 20px;
  font-weight: 600;
  &:hover {
    background: #fff;
    color: #2b3060;
  }
}

@media (max-width: 767px) {
  footer {
    text-align: center;
    &:before {
      background-size: initial;
    }
    .title {
      margin: 30px 0 10px;
    }
    a {
      display: block;
    }
    .fund-raising {
      margin-bottom: 50px;

      a {
        margin: 10px auto 0;
      }
    }
  }
  .start-trial-footer {
    width: 80%;
  }
}
</style>
